<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn depressed
             class="rounded-tag-small normal-btn-text"
             :icon="icon" :color="color"
             v-on="on" @click.stop="onAprove">
        <v-icon v-if="icon">
          mdi-check
        </v-icon>
        <template v-if="!icon">Aprovar</template>
      </v-btn>
    </template>
    <span>Aprovar pedido</span>
    <px-confirm-dialog ref="confirm"/>
  </v-tooltip>
</template>

<script>
import VendaService from '@/modules/vendas/vendas-service';

export default {
  props: {
    venda: Object,
    icon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: null,
    },
  },
  methods: {
    buildAprovacao() {
      return {
        id: this.venda.id,
      };
    },
    aprovar() {
      VendaService.aprovar(this.venda.id, this.buildAprovacao())
        .then(() => {
          this.$emit('update');
          this.$toast('Pedido de compra aprovado', { color: 'success' });
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    onAprove() {
      this.$refs.confirm.open('Você deseja aprovar a compra?',
        'A confirmação será enviada para o cliente e esta operação não poderá ser desfeita.',
        { width: 300 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.aprovar();
        });
    },
  },
};
</script>
